import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes, { Account } from "model";
import TASPositivePaySubmittedChecksPage, { getDefaultData } from "components/pages/TASPositivePaySubmittedChecksPage";
import TASPositivePayCheckForm from "components/pages/TASPositivePayAddChecksPage/classes/TASPositivePayCheckForm";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";

/**
 * @name export default function CapturePositivePayAddACheckPPAddCheckSubmittedChecks(props) {

 * @returns {React.Component}
 * @description A capture in the "Positive Pay - Add a Check" capture group.
 */
export default function CapturePositivePayAddACheckPPAddCheckSubmittedChecks(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const hasBusinessAccounts = Account.hasBusinessAccounts(branding);

    if(!hasBusinessAccounts) {
        const message = Account.businessOnlyBrandingErrorMessage;
        return <CaptureNotShownView message={ message }/>;
    }

    const defaultData = getDefaultData();
    var defaultCheckForm = TASPositivePayCheckForm.init({ account: defaultData.selectedAccount.id });
    defaultCheckForm.checkNumber = "1040";
    defaultCheckForm.amount = "10.00";
    defaultCheckForm.payee = "John Sample";
    const checkForms = [defaultCheckForm];

    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "checkForms" ], checkForms)
    .submit();

    return <TASPositivePaySubmittedChecksPage data={ data } />;
}